import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-oferta-mantenimiento',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './oferta-mantenimiento.component.html',
  styleUrl: './oferta-mantenimiento.component.css'
})
export class OfertaMantenimientoComponent {
  readonly title = 'Mantenimiento de caldera desde 9 €/mes';
  readonly subtitle = 'Seguridad, confort y ahorro para tu hogar.';
  readonly bullets = [
    'Revisión de caldera',
    'Instalación de gas natural',
    'Revisión anual de radiadores'
  ];
  readonly price = '9 €/mes';
  readonly badge = 'Oferta exclusiva invierno 2026';
  readonly badgeNote = '* IVA incluido. Sujeto a condiciones del servicio.';
  readonly route = '/mantenimiento-caldera';
}
